module.exports = __webpack_public_path__ + "assets/05205c1c670d83e2e20c3def7e04ac77.mp3";